import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";

export default class OrganizationService extends AbstractService {
	static endpoint = ENDPOINTS.organizations;

	static getAll(queryParams) {
		return this.get({
			endpoint: this.endpoint,
			queryParams,
		});
	}

	static getAllDetailed(queryParams) {
		return this.get({
			endpoint: `${ENDPOINTS.admin}/${this.endpoint}`,
			queryParams,
		});
	}

	static getDetails(id) {
		return this.get({
			endpoint: `${ENDPOINTS.admin}/${this.endpoint}/${id}`,
		});
	}

	static updateDetails(data) {
		return this.put({
			endpoint: `${ENDPOINTS.admin}/${this.endpoint}`,
			data,
		});
	}

	static updateSignup(id, data) {
		return this.put({
			endpoint: `${ENDPOINTS.admin}/${this.endpoint}/${id}/signup`,
			data,
		});
	}

	static getUsers(id, queryParams = {}) {
		return this.get({
			endpoint: `${ENDPOINTS.admin}/${this.endpoint}/${id}/users`,
			queryParams,
		});
	}

	static getContacts(id, queryParams = {}) {
		return this.get({
			endpoint: `${this.endpoint}/${id}/contacts`,
			queryParams: { ...queryParams, minimalData: false },
		});
	}

	static delete(id, replacementId) {
		return this.del({
			endpoint: `${ENDPOINTS.admin}/${this.endpoint}/${id}`,
			queryParams: { replacementId },
		});
	}

	static uploadImage(fileData, organizationId) {
		const data = new FormData();
		data.append("file", fileData);

		const queryParams = {};
		if (organizationId) {
			queryParams.organizationId = organizationId;
		}

		return this.post({
			endpoint: `${this.endpoint}/picture`,
			queryParams,
			data,
		});
	}

	static uploadPTAEOCodes(fileData, organizationId) {
		const data = new FormData();
		data.append("file", fileData);
		const queryParams = {};
		if (organizationId) {
			queryParams.organizationId = organizationId;
		}

		return this.post({
			endpoint: "ptaeocodes/import",
			queryParams,
			data,
		});
	}

	static getPTAEOCodes() {
		return this.get({
			endpoint: "ptaeocodes",
		});
	}

	static updateOrganizationFees({ organizationFeeModelList }) {
		return this.put({
			endpoint: `${this.endpoint}/organizationsfee`,
			data: { organizationFeeModelList },
		});
	}

	static saveAgency({ id, data, queryParams }) {
		return this.put({
			endpoint: `${this.endpoint}/${id}`,
			data,
			queryParams,
		});
	}

	static getJurisdictionPaymentRules() {
		return this.get({
			endpoint: `${ENDPOINTS.jurisdictionRules}/payment`,
		});
	}

	static saveJurisdictionPaymentRules(data) {
		return this.put({
			endpoint: `${ENDPOINTS.jurisdictionRules}/payment`,
			data,
		});
	}

	static getJurisdictionAgencyRules() {
		return this.get({
			endpoint: `${ENDPOINTS.jurisdictionRules}/agency`,
		});
	}

	static saveJurisdictionAgencyRules(data) {
		return this.put({
			endpoint: `${ENDPOINTS.jurisdictionRules}/agency`,
			data,
		});
	}

	static getJurisdictionOfficerRules() {
		return this.get({
			endpoint: `${ENDPOINTS.jurisdictionRules}/officer`,
		});
	}

	static uploadFileOfficerRules(fileData, organizationId) {
		const data = new FormData();
		data.append("file", fileData);

		const queryParams = {};
		if (organizationId) {
			queryParams.organizationId = organizationId;
		}

		return this.post({
			endpoint: `${ENDPOINTS.jurisdictionRules}/officer/clockinacknowledgement`,
			queryParams,
			data,
		});
	}

	static getClockInOfficerAcknowledgementFile() {
		return this.get({
			endpoint: `${ENDPOINTS.jurisdictionRules}/officer/clockinacknowledgement`,
		});
	}

	static deleteClockInOfficerAcknowledgementFile() {
		return this.del({
			endpoint: `${ENDPOINTS.jurisdictionRules}/officer/clockinacknowledgement`,
		});
	}

	static saveJurisdictionOfficerRules(data) {
		return this.put({
			endpoint: `${ENDPOINTS.jurisdictionRules}/officer`,
			data,
		});
	}

	static getCallOffRange() {
		return this.get({
			endpoint: `${this.endpoint}/9152`,
		});
	}

	static getRkPayRates(id) {
		return this.get({
			endpoint: `${this.endpoint}/${id}/servicefees`,
		});
	}

	static changeRkPayRate(id, data) {
		return this.post({
			endpoint: `${this.endpoint}/${id}/servicefees`,
			data,
		});
	}

	static getInvoiceHistory(id) {
		return this.get({
			endpoint: `${this.endpoint}/${id}/subscriptions/invoices`,
		});
	}

	static getProcessingFees(id, queryParams) {
		return this.get({
			endpoint: `${this.endpoint}/${id}/processingfees`,
			queryParams,
		});
	}

	static updateProcessingFees(id, data) {
		return this.put({
			endpoint: `${this.endpoint}/${id}/processingfees`,
			data,
		});
	}

	static saveProcessingFee(id, data) {
		return this.post({
			endpoint: `${this.endpoint}/${id}/processingfee`,
			data,
		});
	}

	static updateInstantPay(data) {
		return this.put({
			endpoint: `${ENDPOINTS.admin}/clients`,
			data,
		});
	}

	static getAuthenticationSettings(id) {
		return this.get({
			endpoint: `${this.endpoint}/${id}/authenticationSettings`,
		});
	}

	static updateAuthenticationSettings(id, data) {
		return this.put({
			endpoint: `${this.endpoint}/${id}/authenticationSettings`,
			data,
		});
	}

	static hasClientsWithFutureOfficerInvoicingJobs(organizationId) {
		return this.get({
			endpoint: `${this.endpoint}/${organizationId}/hasFutureOfficerJobs`,
		});
	}
}
